module.exports = __webpack_public_path__ + "img/zs-02.1842f6b2.png";